import { usePasteConfig } from '@/components/custom/erp';

interface UseTaxPasteProps {
  columns: any[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<any[]>; resultField?: string }>
  ) => void;
}

export const useTaxPaste = ({ columns, handleUpdateNonWritableFields, handleUpdatePasteConfigs }: UseTaxPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
